import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import DateSearchComponent from "../components/customTable/DateSearchComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Logo from "../../public/img/logoPdf.png";
import Logo1 from "../../public/img/footerPdf.png";
import { toast, ToastContainer } from "react-toastify";
import { ArrowBack, Download } from "@mui/icons-material";
import UserProfileTable from "./UserProfileTable";
import Swal from "sweetalert2";
import axiosInstance from "../utils/axiosInstance";
// import Boot from "./Boot";
const baseUrl = import.meta.env.VITE_BASE_URL;

const UserProfile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const { id } = useParams();
  const [userData, setUserData] = useState([]);
  const [data, setData] = useState([]);
  const [userAddress, setUserAddress] = useState([]);
  const [startDate, setStartDate] = useState(null);

  const [summaryData, setSummaryData] = useState([]);
  const [summarySilverData, setSummarySilverData] = useState([]);
  // const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  function getThirtyDaysBackDate() {
    if (!startDate) {
      const thirtyDaysBack = moment().subtract(30, "days");
      return thirtyDaysBack.format("DD MMM YYYY");
    }

    // Ensure startDate is parsed as a moment object
    const startDate1 = moment(startDate); // Corrected this line
    return startDate1.format("DD MMM YYYY");
  }

  function getThirtyDaysBackDate2() {
    if (!endDate) {
      const today = moment(); // Current date
      return today.format("DD MMM YYYY"); // Format the date
    }
    const endData1 = moment(endDate);
    return endData1.format("DD MMM YYYY");
  }

  const userTransactions = async (startDate, endDate) => {
    try {
      const queryParams = new URLSearchParams({
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
      });
      const url = `/userReports/${id}?${queryParams.toString()}`;
      // const url = `${baseUrl}/userReports/${id}?${queryParams.toString()}`;
      const token = localStorage.getItem("token");

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });
      setData(response?.data?.data);
      setUserData(response?.data?.data?.userDetails);
      setUserAddress(response?.data?.data?.address);
      setSummaryData(response?.data?.data?.goldSummary);
      setSummarySilverData(response?.data?.data?.silverSummary);

      // Refresh the user list
    } catch (error) {
      console.error("Error the user", error);
    }
  };
  useEffect(() => {
    userTransactions(startDate, endDate);
  }, []);

  const handleSearch = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    userTransactions(startDate, endDate); // Call the API with updated dates
  };

  const [goldPage, setGoldPage] = useState(0);
  const [silverPage, setSilverPage] = useState(0);
  const [goldRowsPerPage, setGoldRowsPerPage] = useState(10);
  const [silverRowsPerPage, setSilverRowsPerPage] = useState(10);

  const handleGoldChangePage = (event, newPage) => {
    setGoldPage(newPage);
  };

  const handleGoldChangeRowsPerPage = (event) => {
    setGoldRowsPerPage(parseInt(event.target.value, 10));
    setGoldPage(0);
  };

  const goldPaginatedData = data?.goldData;
  // const goldPaginatedData = data?.goldData?.slice(
  //   goldPage * goldRowsPerPage,
  //   goldPage * goldRowsPerPage + goldRowsPerPage
  // );

  const handleSilverChangePage = (event, newPage) => {
    setSilverPage(newPage);
  };

  const handleSilverChangeRowsPerPage = (event) => {
    setSilverRowsPerPage(parseInt(event.target.value, 10));
    setSilverPage(0);
  };

  const silverPaginatedData = data?.silverData;
  // const silverPaginatedData = data?.silverData?.slice(
  //   silverPage * silverRowsPerPage,
  //   silverPage * silverRowsPerPage + silverRowsPerPage
  // );

  const generatePdf = async () => {
    if (!data) return;

    const doc = new jsPDF();

    // doc.addImage(Logo, "PNG", 0, 0, 210, 26);
    const headerHeight = 26; // Adjust this based on your header image height
    const footerHeight = 20;
    const pageHeight = doc.internal.pageSize.height;

    const header = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);

        doc.addImage(Logo, "PNG", 0, 0, 210, 25);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
      }
    };

    const footer = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const pageHeight = doc.internal.pageSize.height;

        const pageWidth = doc.internal.pageSize.width;
        // const pageHeight = doc.internal.pageSize.height;

        // Add footer image (Logo1)

        doc.addImage(Logo1, "PNG", 0, pageHeight - 20, 210, 20);
        doc.setTextColor(238, 216, 129);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(
          `Page ${i} of ${pageCount}`,
          pageWidth - 30,
          pageHeight - 7.5,
          {
            align: "justify",
          },
        );
      }
    };

    const addContent = async () => {
      // Set initial content Y position (below the header)
      let currentY = headerHeight + 5;

      // User Details Section
      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.setTextColor(0, 58, 72);
      doc.text("User Details", 14, currentY + 2);
      currentY += 5;

      const userDetails = [
        ["Name", data?.userDetails?.name || "N/A"],
        ["Phone", data?.userDetails?.phone || "N/A"],
        ["DOB", data?.userDetails?.dob || "N/A"],
        ["Email", data?.userDetails?.email || "N/A"],
        [
          "Address",
          data?.address
            ? `${data.address.line1 || "N/A"}, ${
                data.address.line2 || "N/A"
              }, ${data.address.city || "N/A"}, ${
                data.address.state || "N/A"
              }, ${data.address.zip || "N/A"}`
            : "N/A",
        ],
        ["Unique ID", data?.userDetails?.uniqueId || "N/A"],
      ];

      doc.autoTable({
        body: userDetails,
        startY: currentY,
        theme: "plain",
        margin: { top: headerHeight + 5, bottom: footerHeight + 5 },
        didDrawPage: () => {
          header(doc);
          footer(doc);
        },
      });
      currentY = doc.lastAutoTable.finalY + 10;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(
        `Transactions Statement from ${
          startDate
            ? moment(startDate).format("DD MMM YYYY")
            : getThirtyDaysBackDate()
        } to ${getThirtyDaysBackDate2()}.`,
        14,
        currentY - 4,
      );

      // Gold Transactions Section
      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.setTextColor(0, 58, 72);
      doc.text("Gold Transactions", 14, currentY + 5);
      currentY += 9;

      const goldData = data?.goldData || [];
      const goldTransactionRows = goldData.map((row) => [
        moment(row.createdAt).format("DD MMM YYYY"),
        row.refinery == "augmont"
          ? "Augmont"
          : "MMTC-PAMP" || row.refinery || "N/A",
        row.description,
        row.type === "buy" ? row.gram : "",
        row.type === "sell" ? row.gram : "",
        row.type === "redeem" ? row.gram : "",
        row.amount,
        row?.balance,
      ]);

      const lastGoldRow = goldTransactionRows?.at(-1);

      const TotalGoldBy_Sell = (
        data?.goldSummary?.totalBuyAmount - data?.goldSummary?.totalSellAmount
      ).toFixed(2);

      if (lastGoldRow) {
        goldTransactionRows.push([
          {
            content: "Total",
            colSpan: 3,
            styles: { halign: "left", fontStyle: "bold" },
          }, // ✅ First 3 columns merged: Date + Refinery + Description
          data?.goldSummary?.totalBuyGram || "0.0000", // ✅ Buy(g)
          data?.goldSummary?.totalSellGram || "0.0000", // ✅ Sell(g)
          data?.goldSummary?.totalRedeemGram || "0.0000",
          TotalGoldBy_Sell || "0.00", // ✅ Amount(Rs)
          lastGoldRow[7] || "0.0000", // ✅ Balance(g)
        ]);
      }

      // if (lastGoldRow) {
      //   goldTransactionRows.push([
      //     { content: "Total", styles: { fontStyle: "bold" } },
      //     "",
      //     data?.goldSummary?.totalBuyGram || "N/A",
      //     data?.goldSummary?.totalSellGram || "N/A",
      //     TotalGoldBy_Sell || "N/A",
      //     lastGoldRow[5] || "N/A",
      //   ]);
      // }

      doc.autoTable({
        head: [
          [
            "Date",
            "Refinery",
            "Description",
            "Buy(g)",
            "Sell(g)",
            "Redeem(g)",
            "Amount(Rs)",
            "Balance(g)",
          ],
        ],
        body:
          goldTransactionRows.length > 0
            ? goldTransactionRows
            : [
                [
                  {
                    content: "No Transactions Available",
                    colSpan: 7,
                    styles: { halign: "center" },
                  },
                ],
              ],
        columnStyles: {
          0: { cellWidth: "auto" },
          // 1: { cellWidth: "auto" },
          1: { halign: "left" },
          2: { halign: "left" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
          7: { halign: "right" },
        },
        startY: currentY,
        theme: "grid",
        margin: { top: headerHeight + 5, bottom: footerHeight + 5 },
        headStyles: {
          fillColor: [0, 58, 72],
          textColor: [255, 255, 255],
          fontSize: 8,
          fontStyle: "bold",
        },
        // columnStyles: {
        //   // Only set alignment for these columns
        //   2: { halign: "right" }, // Buy
        //   3: { halign: "right" }, // Sell
        //   4: { halign: "right" }, // Amount
        //   5: { halign: "right" }, // Balance
        // },

        didDrawPage: () => {
          header(doc);
          footer(doc);
        },
      });
      currentY = doc.lastAutoTable.finalY + 10;

      // Gold Summary Section
      if (doc.lastAutoTable.finalY > pageHeight - footerHeight - 30) {
        doc.addPage();
        currentY = headerHeight + 5; // Start new page content
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(0, 58, 72);
      doc.text("Gold Summary", 14, currentY + 2);
      currentY += 5;

      const goldSummary = [
        ["Total Gold Buy (gm)", data?.goldSummary?.totalBuyGram || "N/A"],
        // ["Total Gold Bought (gm)", data?.goldSummary?.totalBuyGram || "N/A"],
        [
          "Total Gold Buy Amount (Rs.)",
          data?.goldSummary?.totalBuyAmount || "N/A",
        ],
        ["Total Gold Sell (gm)", data?.goldSummary?.totalSellGram || "N/A"],
        [
          "Total Gold Sell Amount (Rs.)",
          data?.goldSummary?.totalSellAmount || "N/A",
        ],
      ];
      doc.autoTable({
        body: goldSummary,
        startY: currentY,
        theme: "plain",
        margin: { top: headerHeight + 5, bottom: footerHeight + 5 },
        didDrawPage: () => {
          header(doc);
          footer(doc);
        },
      });
      currentY = doc.lastAutoTable.finalY + 10;

      // Silver Transactions Section
      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.setTextColor(0, 58, 72);
      doc.text("Silver Transactions", 14, currentY + 4);
      currentY += 9;

      const silverData = data?.silverData || [];
      const silverTransactionRows = silverData.map((row) => [
        moment(row.createdAt).format("DD MMM YYYY"),
        row.refinery == "augmont"
          ? "Augmont"
          : "MMTC-PAMP" || row.refinery || "N/A",
        row.description,
        row.type === "buy" ? row.gram : "",
        row.type === "sell" ? row.gram : "",
        row.type === "redeem" ? row.gram : "",
        row.amount,
        row?.balance,
      ]);

      const lastSilverRow = silverTransactionRows?.at(-1);

      const TotalSiBy_Sell = (
        data?.silverSummary?.totalBuyAmount -
        data?.silverSummary?.totalSellAmount
      ).toFixed(2);

      if (lastSilverRow) {
        silverTransactionRows.push([
          {
            content: "Total",
            colSpan: 3,
            styles: { halign: "left", fontStyle: "bold" },
          }, // ✅ First 3 columns merged: Date + Refinery + Description
          data?.silverSummary?.totalBuyGram || "0.0000", // ✅ Buy(g)
          data?.silverSummary?.totalSellGram || "0.0000", // ✅ Sell(g)
          data?.silverSummary?.totalRedeemGram || "0.0000",
          TotalSiBy_Sell || "0.00", // ✅ Amount(Rs)
          lastSilverRow[7] || "0.0000", // ✅ Balance(g)
        ]);
      }

      const headers = [
        "Date",
        "Refinery",
        "Description",
        "Buy(g)",
        "Sell(g)",
        "Redeem(g)",
        "Amount(Rs)",
        "Balance(g)",
      ];

      doc.autoTable({
        head: [headers],
        body:
          silverTransactionRows.length > 0
            ? silverTransactionRows
            : [
                [
                  {
                    content: "No Transactions Available",
                    colSpan: 7,
                    styles: { halign: "center" },
                  },
                ],
              ],
        columnStyles: {
          0: { cellWidth: "auto" },
          1: { halign: "left" },
          2: { halign: "left" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
          7: { halign: "right" },
        },
        startY: currentY,
        theme: "grid",
        margin: { top: headerHeight + 5, bottom: footerHeight + 5 },
        headStyles: {
          fillColor: [0, 58, 72],
          textColor: [255, 255, 255],
          fontSize: 8,
          fontStyle: "bold",
        },
        didDrawPage: () => {
          header(doc);
          footer(doc);
        },
      });

      currentY = doc.lastAutoTable.finalY + 10;

      // Silver Summary Section
      if (doc.lastAutoTable.finalY > pageHeight - footerHeight - 30) {
        doc.addPage();
        currentY = headerHeight + 5; // Start new page content
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(0, 58, 72);
      doc.text("Silver Summary", 14, currentY);
      currentY += 4;

      const silverSummary = [
        ["Total Silver Buy (gm)", data?.silverSummary?.totalBuyGram || "N/A"],
        [
          "Total Silver Buy Amount (Rs.)",
          data?.silverSummary?.totalBuyAmount || "N/A",
        ],
        ["Total Silver Sell (gm)", data?.silverSummary?.totalSellGram || "N/A"],
        [
          "Total Silver Sell Amount (Rs.)",
          data?.silverSummary?.totalSellAmount || "N/A",
        ],
      ];

      doc.autoTable({
        body: silverSummary,
        startY: currentY,
        theme: "plain",
        margin: { top: headerHeight + 5, bottom: footerHeight + 5 },
        didDrawPage: () => {
          header(doc);
          footer(doc);
        },
      });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.setTextColor(100);
      let marginBottom = 5; // Define your margin value
      let textYPosition = doc.lastAutoTable.finalY + marginBottom;

      doc.text(
        "**This is a computer-generated statement and does not require a signature.",
        14,
        textYPosition,
      );
    };

    // Generate PDF content
    await addContent();

    // Finalize PDF and return blob URL

    return new Promise((resolve) => {
      setTimeout(() => {
        const pdfOutput = doc.output("bloburl");

        resolve(pdfOutput);
      }, 10);
    });

    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     const pdfOutput = doc.output("bloburl");

    //     resolve(pdfOutput);
    //   }, 1000);
    // });

    // return pdfOutput;
  };

  const handleDownload = async () => {
    if (data?.goldData?.length <= 0 && data?.silverData?.length <= 0) {
      await Swal.fire({
        icon: "error",
        title: "No Transactions Available !",
        showConfirmButton: false,
        timer: 1500,
      });
      // toast.warn("No Transactions Available !", {
      //   position: "top-center",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: false,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      return;
    }
    setLoading1(true);
    try {
      const pdfOutput = await generatePdf();
      const link = document.createElement("a");
      link.href = pdfOutput;
      if (data?.goldData?.length > 0 || data?.silverData?.length > 0) {
        link.download = "Transaction_Reports.pdf";
        link.click();
        await Swal.fire({
          icon: "success",
          title: "Pdf Downloaded successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        // toast.success("Download pdf !", {
        //   position: "top-center",
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   closeOnClick: false,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "light",
        // });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading1(false);
    }
  };

  const handleView = async () => {
    if (data?.goldData?.length <= 0 && data?.silverData?.length <= 0) {
      await Swal.fire({
        icon: "error",
        title: "No Transactions Available !",
        showConfirmButton: false,
        timer: 1500,
      });
      // toast.warn("No Transactions Available !", {
      //   position: "top-center",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: false,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      return;
    }
    setLoading(true);

    try {
      // toast.success("View content in pdf !", {
      //   position: "top-center",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: false,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      const pdfOutput = await generatePdf();

      if (data?.goldData?.length > 0 || data?.silverData?.length > 0) {
        window.open(pdfOutput, "_blank");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendMail = async () => {
    if (data?.goldData?.length <= 0 && data?.silverData?.length <= 0) {
      await Swal.fire({
        icon: "error",
        title: "No Transactions Available !",
        showConfirmButton: false,
        timer: 1500,
      });
      // toast.warn("No Transactions Available !", {
      //   position: "top-center",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: false,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      return;
    }
    setLoading2(true);
    try {
      const pdfOutput = await generatePdf();
      const blob = await (await fetch(pdfOutput)).blob();
      if (data?.goldData?.length > 0 || data?.silverData?.length > 0) {
        await handleMail(blob);
        await Swal.fire({
          icon: "success",
          title: "Mail sent Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        // toast.success("Send pdf to mail !", {
        //   position: "top-center",
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   closeOnClick: false,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "light",
        // });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading2(false);
    }
  };

  const handleMail = async (blob) => {
    const url = `/sendMail/${id}`;
    // const url = `${baseUrl}/sendMail/${id}`;
    const token = localStorage.getItem("token");

    if (!blob || blob.size === 0) {
      console.error("Blob is empty or invalid.");
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const formData = new FormData();
    formData.append("file", blob, "Transaction_Reports.pdf");
    formData.append("startDate", getThirtyDaysBackDate());
    formData.append("endDate", getThirtyDaysBackDate2());

    try {
      const response = await axiosInstance.post(
        url,
        formData,
        //   {
        //   headers,
        // }
      );
      // console.log("Mail sent successfully:", response.data);
    } catch (error) {
      console.error("Error sending mail:", error);
    }
  };
  const leftArrow = () => {
    navigate("/users");
  };

  return (
    <>
      <ToastContainer />
      <Box sx={{ marginTop: 0 }}>
        <Button onClick={leftArrow}>
          <ArrowBack
            size="small"
            sx={{ margin: 0, padding: 0, cursor: "pointer" }}
          />
        </Button>
        <DateSearchComponent onSearch={handleSearch} />
      </Box>
      <Box>
        <Box
          sx={{
            padding: 2,
            paddingTop: 0,
            paddingBottom: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h5"
            style={{ fontStyle: "bold", color: "#4a2a7d", fontSize: 24 }}
          >
            User Details
          </Typography>
        </Box>
        <Box
          sx={{
            // border: "1px solid #DCDAFF", // Border color and style
            borderRadius: 2, // Rounded corners
            padding: 2, // Inner spacing
            maxWidth: "auto", // Adjust the width as needed
            backgroundColor: "#4a2a7d", // Optional background color
            color: "white",
          }}
        >
          <Grid container spacing={2}>
            {/* Username */}
            <Grid item xs={5}>
              <Box sx={{ paddingLeft: 2 }}>Name</Box>
            </Grid>
            <Grid item xs={7}>
              <Box>{userData.name || "N/A"}</Box>
            </Grid>

            {/* Unique Id */}
            <Grid item xs={5}>
              <Box sx={{ paddingLeft: 2 }}>DOB</Box>
            </Grid>
            <Grid item xs={7}>
              <Box>{userData.dob || "N/A"}</Box>
            </Grid>

            {/* Mobile No */}
            <Grid item xs={5}>
              <Box sx={{ paddingLeft: 2 }}>Mobile No.</Box>
            </Grid>
            <Grid item xs={7}>
              <Box>{userData.phone || "N/A"}</Box>
            </Grid>

            {/* Email */}
            <Grid item xs={5}>
              <Box sx={{ paddingLeft: 2 }}>Email</Box>
            </Grid>
            <Grid item xs={7}>
              <Box>{userData.email || "N/A"}</Box>
            </Grid>
            {/* Unique Id */}
            <Grid item xs={5}>
              <Box sx={{ paddingLeft: 2 }}>Address</Box>
            </Grid>
            <Grid item xs={7}>
              <Box>
                <span> {userAddress?.line1 || "N/A"},</span>
                <span> {userAddress?.line2 || "N/A"},</span>
                <span> {userAddress?.city || "N/A"},</span>
                <span> {userAddress?.state || "N/A"},</span>
                <span> {userAddress?.zip || "N/A"}</span>
              </Box>
            </Grid>
            {/* Unique Id */}
            <Grid item xs={5}>
              <Box sx={{ paddingLeft: 2 }}>Unique Id</Box>
            </Grid>
            <Grid item xs={7}>
              <Box>{userData.uniqueId || "N/A"}</Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ padding: 1, marginTop: 2 }}>
          <Typography style={{ fontStyle: "bold", color: "#4a2a7d" }}>
            Transactions Statement from{" "}
            {startDate
              ? moment(startDate).format("DD MMM YYYY")
              : getThirtyDaysBackDate()}{" "}
            to {getThirtyDaysBackDate2()}.
          </Typography>
        </Box>
        <hr />
        {data?.goldData?.length > 0 || data?.silverData?.length > 0 ? (
          <>
            <Box sx={{ padding: 2 }}>
              <Typography
                variant="h5"
                style={{ fontStyle: "bold", color: "#4a2a7d", fontSize: 24 }}
              >
                Gold
              </Typography>
            </Box>

            {/* goldtable */}
            <UserProfileTable GoldData={goldPaginatedData} />

            {data?.goldData?.length > 0 ? (
              <>
                <Box sx={{ padding: 2 }}>
                  <Typography
                    variant="h5"
                    style={{
                      fontStyle: "bold",
                      color: "#4a2a7d",
                      fontSize: 24,
                    }}
                  >
                    Gold Summary
                  </Typography>
                </Box>
                <Box
                  sx={{
                    // border: "1px solid #DCDAFF", // Border color and style
                    borderRadius: 2, // Rounded corners
                    padding: 2, // Inner spacing
                    maxWidth: "auto", // Adjust the width as needed
                    color: "white",
                    backgroundColor: "#4a2a7d", // Optional background color
                  }}
                >
                  <Grid container spacing={2}>
                    {/* Username */}
                    <Grid item xs={5}>
                      {/* <Box sx={{ paddingLeft: 2 }}>Total Gold Bought (gm)</Box> */}
                      <Box sx={{ paddingLeft: 2 }}>Total Gold Buy (gm)</Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summaryData.totalBuyGram}</Box>
                    </Grid>

                    {/* Unique Id */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>
                        Total Gold Buy Amount (Rs.)
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summaryData.totalBuyAmount}</Box>
                    </Grid>

                    {/* Mobile No */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>Total Gold Sell (gm)</Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summaryData.totalSellGram}</Box>
                    </Grid>

                    {/* Email */}
                    {/* <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>
                        Total Gold Sell Bought (gm)
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summaryData.totalBuyGram}</Box>
                    </Grid> */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>
                        Total Gold Sell Amount (Rs.)
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summaryData.totalSellAmount}</Box>
                    </Grid>
                  </Grid>
                </Box>
              </>
            ) : (
              <p style={{ fontStyle: "bold", color: "#4a2a7d", fontSize: 24 }}>
                No Gold Summary !
              </p>
            )}
            {/* </> */}
            <hr style={{ marginTop: 15 }} />

            <Box sx={{ padding: 2, paddingTop: 1 }}>
              <Typography
                variant="h5"
                style={{ fontStyle: "bold", color: "#4a2a7d", fontSize: 24 }}
              >
                Silver
              </Typography>
            </Box>

            {/* silerData */}

            <UserProfileTable SilverData={silverPaginatedData} />

            {/* <Grid item xs={12} md={6}>
              <TableContainer
                component={Paper}
                sx={{
                  // border: "2px solid #4a2a7d", // Light gray border
                  borderRadius: "5px",
                  overflow: "hidden",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        background: "#4a2a7d",
                        border: "2.5px solid #4a2a7d",
                      }}
                    >
                      <TableCell
                        sx={{
                          border: "1px solid #DCDAFF",
                          borderTop: "0",
                          // borderBottom:"0",
                          overflow: "hidden",
                          color: "white",
                        }}
                      >
                        Date
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #DCDAFF",
                          borderTop: "0",

                          color: "white",
                          overflow: "hidden",
                        }}
                      >
                        Description
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #DCDAFF",
                          color: "white",
                          borderTop: "0",
                          overflow: "hidden",
                        }}
                      >
                        Buy(g)
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #DCDAFF",
                          color: "white",
                          borderTop: "0",
                          overflow: "hidden",
                        }}
                      >
                        Sell(g)
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #DCDAFF",
                          borderTop: "0",
                          color: "white",
                          overflow: "hidden",
                        }}
                      >
                        Amount(Rs)
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          border: "1px solid #DCDAFF",
                          borderTop: "0",
                          overflow: "hidden",
                        }}
                      >
                        Balance(g)
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.silverData.length > 0 ? (
                      silverPaginatedData?.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell
                            sx={{
                              border: "1px solid #ddd",
                              overflow: "hidden",
                            }}
                          >
                            {moment(row.createdAt).format("DD MMM YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #ddd",
                              overflow: "hidden",
                            }}
                          >
                            {row.description}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #ddd",
                              overflow: "hidden",
                            }}
                          >
                            {row.type === "buy" ? row.gram : ""}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #ddd",
                              overflow: "hidden",
                            }}
                          >
                            {row.type === "sell" ? row.gram : ""}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #ddd",
                              overflow: "hidden",
                            }}
                          >
                            {row.amount}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #ddd",
                              overflow: "hidden",
                            }}
                          >
                            {row?.balance}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          align="center"
                          sx={{ color: "#4a2a7d", fontWeight: "bold" }}
                        >
                          No Transactions Available !
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                <TablePagination
                  rowsPerPageOptions={[10, 20, 30]}
                  component="div"
                  count={data?.silverData?.length || 0}
                  rowsPerPage={silverRowsPerPage}
                  page={silverPage}
                  onPageChange={handleSilverChangePage}
                  onRowsPerPageChange={handleSilverChangeRowsPerPage}
                />
              </TableContainer>
            </Grid> */}

            {data?.silverData.length > 0 ? (
              <>
                {" "}
                <Box sx={{ padding: 2 }}>
                  <Typography
                    variant="h5"
                    style={{
                      fontStyle: "bold",
                      color: "#4a2a7d",
                      fontSize: 24,
                    }}
                  >
                    Silver Summary
                  </Typography>
                </Box>
                <Box
                  sx={{
                    // border: "1px solid #DCDAFF", // Border color and style
                    borderRadius: 2, // Rounded corners
                    padding: 2, // Inner spacing
                    maxWidth: "auto", // Adjust the width as needed
                    color: "white",
                    backgroundColor: "#4a2a7d", // Optional background color
                  }}
                >
                  <Grid container spacing={2}>
                    {/* Username */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>Total Silver Buy (gm)</Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summarySilverData.totalBuyGram}</Box>
                    </Grid>

                    {/* Unique Id */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>
                        Total Silver Buy Amount (Rs.)
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summarySilverData.totalBuyAmount}</Box>
                    </Grid>

                    {/* Mobile No */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>Total Silver Sell (gm)</Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summarySilverData.totalSellGram}</Box>
                    </Grid>

                    {/* Email */}
                    {/* <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>
                        Total Silver Sell Bought (gm)
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summarySilverData.totalBuyGram}</Box>
                    </Grid> */}
                    <Grid item xs={5}>
                      <Box sx={{ paddingLeft: 2 }}>
                        Total Silver Sell Amount (Rs.)
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Box>{summarySilverData.totalSellAmount}</Box>
                    </Grid>
                  </Grid>
                </Box>
              </>
            ) : (
              <p style={{ fontStyle: "bold", color: "#4a2a7d", fontSize: 24 }}>
                No Silver Summary !
              </p>
            )}
          </>
        ) : (
          <p
            style={{
              margin: "50px 0",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bolder",
            }}
          >
            No Transaction Available !
          </p>
        )}
      </Box>

      <Box
        sx={{
          padding: 2,
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mx: -2,
        }}
      >
        <Button
          variant="contained"
          disabled={loading1}
          sx={{
            ...(loading1 && {
              color: "white",
              "&.Mui-disabled": {
                color: "white",
              },
            }),
          }}
          startIcon={
            loading1 ? <CircularProgress size={20} color="white" /> : null
          }
          onClick={handleDownload}
        >
          Download PDF
        </Button>

        <Button
          variant="contained"
          disabled={loading} // Disable button when loading is true
          sx={{
            ...(loading && {
              color: "white",
              "&.Mui-disabled": {
                color: "white",
              },
            }),
          }}
          startIcon={
            loading ? <CircularProgress size={20} color="white" /> : null
          }
          onClick={handleView}
        >
          View PDF
        </Button>

        <Button
          variant="contained"
          disabled={loading2}
          sx={{
            ...(loading2 && {
              color: "white",
              "&.Mui-disabled": {
                color: "white",
              },
            }),
          }}
          startIcon={
            loading2 ? <CircularProgress size={20} color="white" /> : null
          }
          onClick={handleSendMail}
        >
          Send Pdf To Mail
        </Button>
      </Box>
      {/* <Boot/> */}
    </>
  );
};

export default UserProfile;
